
export const getToken = () => {
  let tokenInfo = sessionStorage.getItem("TokenInfo")
    ? JSON.parse(sessionStorage.getItem("TokenInfo"))
    : null;

  if (tokenInfo === "undefined") {
    return null;
  }

  if (tokenInfo !== null) {
    /*const expireTime = new Date(tokenInfo.expires_in).getTime();
    let currentTime = new Date().toUTCString();
    currentTime = currentTime.replace(" GMT", "");
    currentTime = new Date(currentTime).getTime(); */
    const expireTime = tokenInfo.expires_in;
    const currentTime = new Date().getTime();
    
    if (currentTime < expireTime) {
      return tokenInfo;
    } else {
      sessionStorage.removeItem("TokenInfo");
      return null;
    }
  }

}